<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vx-card>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="timeList"
            :description="false"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="heading">
                {{ $t("setup.label.TimePeriod") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create Time Model' })"
                  size="small"
                  >{{ $t("setup.label.CreateTimePeriod") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.TimeModelName") }}</vs-th>
              <vs-th>{{ $t("setup.label.StartYear") }}</vs-th>
              <vs-th>{{ $t("setup.label.EndYear") }}</vs-th>
              <vs-th>{{ $t("setup.label.StartMonth") }}</vs-th>
              <vs-th>{{ $t("setup.label.EndMonth") }}</vs-th>
              <vs-th>{{ $t("setup.label.StartDay") }}</vs-th>
              <vs-th>{{ $t("setup.label.EndDay") }}</vs-th>
              <vs-th>{{ $t("setup.label.StartTime") }}</vs-th>
              <vs-th>{{ $t("setup.label.EndTime") }}</vs-th>
              <!-- <vs-th>{{ $t("label.heading.actions") }}</vs-th> -->
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="Timemodel"
                v-for="(Timemodel, index) in data"
              >
                <vs-td :data="Timemodel.timeModelName">{{
                  Timemodel.timeModelName
                }}</vs-td>

                <vs-td :data="Timemodel.startYear">{{
                  Timemodel.startYear
                }}</vs-td>
                <vs-td :data="Timemodel.endYear">{{ Timemodel.endYear }}</vs-td>
                <vs-td :data="Timemodel.startMonth">{{
                  Timemodel.startMonth
                }}</vs-td>
                <vs-td :data="Timemodel.endMonth">{{
                  Timemodel.endMonth
                }}</vs-td>
                <vs-td :data="Timemodel.startDay">{{
                  Timemodel.startDay
                }}</vs-td>
                <vs-td :data="Timemodel.endDay">{{ Timemodel.endDay }}</vs-td>
                <vs-td :data="Timemodel.startTime">{{
                  Timemodel.startTime
                }}</vs-td>
                <vs-td :data="Timemodel.endTime">{{ Timemodel.endTime }}</vs-td>

                <!-- <vs-td class="whitespace-no-wrap">
                      <feather-icon
                        icon="EditIcon"
                        title="edit"
                        svgClasses="w-5 h-5 text-warning hover:text-primary stroke-current cursor"
                        @click.stop="editTimemodel(Timemodel.timeperiodId)"
                        class="ml-2"
                      />
                      <feather-icon
                        icon="TrashIcon"
                        title="delete"
                        svgClasses="w-5 h-5 text-warning hover:text-primary stroke-current cursor"
                        @click.stop="
                          stateChange('Timemodel');
                          editJobsPopup = true;
                          delId = Timemodel.id;
                        "
                        class="ml-2"
                      />
                    </vs-td> -->
              </vs-tr>
            </template>
          </vs-table>
          <div class="centerx">
            <vs-popup
              classContent="popup-example"
              :title="$t('setup.label.DeleteRUM')"
              :active.sync="editJobsRumPopup"
              class="popup-close mid-popup"
            >
              <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                <div class="vx-col sm:w-full w-full">
                  <div class="vx-col sm:w-full w-full">{{$t("setup.label.Are_you_sure_?")}}</div>
                </div>
              </div>
              <div class="vx-row">
                <span class="ml-4 mr-1">
                  <vs-button type="border" @click="editJobsRumPopup = false">{{
                    $t("setup.label.Cancel")
                  }}</vs-button>
                </span>
                <span class="ml-1 mr-2">
                  <vs-button @click="deleteRumTeam(delId)" color="warning">{{
                    $t("setup.label.Ok")
                  }}</vs-button>
                </span>
              </div>
            </vs-popup>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
      deleatId: 0,
      editJobsPopup: false,
      editJobsUomPopup: false,
      editJobsRumPopup: false,
      // provisioningRumList: [],
      // hardwareUomList: [],
      provisioningActionsList: [],
      networkElementList: [],
      timeList: [],
    };
  },
  components: { AtomSpinner },

  computed: {
    ...mapState({
      hardwareUomList: (state) => state.usageRating.Uomlist,
      provisioningRumList: (state) => state.usageRating.Rumlist,
      Timemodel: (state) => state.usageRating.GetTimePeriod,
      broadcasters: (state) => state.usageRating.GetTemplate,
      products: (state) => state.usageRating.GetUsageRatePlan,
      timemodel: (state) => state.usageRating.timeModelList,
    }),
  },
  methods: {
    async getTimeModelData() {
      try {
        this.$store.dispatch("usageRating/setTimePeriodList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async getTimemodelList() {
      this.loading = true;
      try {
        await this.$store.dispatch("usageRating/setTimeModelList");
        const myList = [];
        const myObj = {};
        if (this.timemodel.length == 0) return;
        for (const timeModel of this.timemodel) {
          myObj.timeModelName = timeModel.timemodelName;
          if (timeModel.year.length == 0) {
            myObj.startMonth = "-";
            myObj.endMonth = "-";
            myObj.startDay = "-";
            myObj.endDay = "-";
            myObj.startTime = "-";
            myObj.endTime = "-";
            myObj.startYear = "-";
            myObj.endYear = "-";
            myList.push({ ...myObj });
          }
          for (const year of timeModel.year) {
            myObj.startYear = year.startYear;
            myObj.endYear = year.endYear;
            if (year.month.length == 0) {
              myObj.startMonth = "-";
              myObj.endMonth = "-";
              myObj.startDay = "-";
              myObj.endDay = "-";
              myObj.startTime = "-";
              myObj.endTime = "-";
              myList.push({ ...myObj });
            }
            for (const month of year.month) {
              myObj.startMonth = month.startMonth;
              myObj.endMonth = month.endMonth;
              if (month.day.length == 0) {
                myObj.startDay = "-";
                myObj.endDay = "-";
                myObj.startTime = "-";
                myObj.endTime = "-";
                myList.push({ ...myObj });
              }
              for (const day of month.day) {
                myObj.startDay = day.startDay;
                myObj.endDay = day.endDay;
                if (day.time.length == 0) {
                  myObj.startTime = "-";
                  myObj.endTime = "-";
                  myList.push({ ...myObj });
                }
                for (const time of day.time) {
                  myObj.startTime = time.startTime;
                  myObj.endTime = time.endTime;
                  myList.push({ ...myObj });
                }
              }
            }
          }
        }
        this.timeList = myList;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
  },
  mounted() {
    this.getTimemodelList();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.heading {
  margin-right: auto;
  font-size: 1.5rem;
  font-weight: 600;
  margin-left: 5px;
}
</style>
